const notFoundPages = ['/404/', '/notfound/'];
const isNotFound = structure =>
  structure?.id === '404' && !notFoundPages.includes(structure?.resolvedUrl);

export default isNotFound;
